import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

import { AdminReportsService } from 'rev-portal/admin/reports/AdminReports.Service';
import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { VideoType } from 'rev-shared/media/VideoType';
import { notApplicableValueFormatter } from 'rev-shared/ui/dataGrid/valueFormatters/NotApplicableValueFormatter';

import styles from 'rev-portal/admin/reports/AdminReports.module.less';

@Component({
	selector: 'videos-top-hits-grid',
	templateUrl: './VideosTopHitsGrid.Component.html'
})
export class VideosTopHitsGridComponent implements OnInit {
	@Input() public accountId: string;
	@Input() public header: string;
	@Input() public topHitsCount: number;

	public readonly styles = styles;
	public data$: Observable<any>;

	public readonly notApplicableValueFormatter = params => notApplicableValueFormatter(params, params.data?.VideoType === VideoType.LIVE);

	constructor(
		public AnalyticsService: AnalyticsService,
		public ReportsService: AdminReportsService
	){}

	public ngOnInit(): void {
		this.data$ = this.AnalyticsService.dataFetchContext$
			.pipe(
				filter(context => !!context?.startDate),
				distinctUntilChanged(),
				switchMap(context => this.ReportsService.getVideoTopHits(this.accountId, this.topHitsCount, context)),
				map(result => result.videos)
			);
	}

}
